export const defaultSWRConfig = {
    revalidateOnFocus: false,
    keepPreviousData: true,
    shouldRetryOnError: false,
};
